import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Modal, TextInput } from 'Components/atoms'
import colors from 'Assets/colors'
import useShoppingListsCreateModal from 'hooks/shoppingLists/useShoppingListsCreateModal'
import { SHOPPING_LIST_TITLE_MAX_LENGTH } from 'Config/constants'

import {
  Title,
  Message,
  InputLabel,
  InputContainer,
  ActionButton,
  ButtonLiteral,
  CircularProgressStyled,
} from './styled'

const ModalCreateShoppingList = ({ showModal, setShowModal }) => {
  const { t } = useTranslation()
  const { name, error, isLoading, onSubmit, onChangeName } = useShoppingListsCreateModal({ showModal, setShowModal })

  return (
    <Modal showClose isOpen={showModal} setIsOpen={setShowModal} height='390px'>
      <Title>{t('shoppingList.create.title')}</Title>
      <InputContainer>
        <InputLabel>{t('shoppingList.create.label')}</InputLabel>
        <TextInput
          value={name}
          placeholder={t('shoppingList.create.placeholder')}
          borderRadius='8px'
          background='#F4F1F1'
          margin='0 0 24px'
          height='56px'
          onChange={onChangeName}
          name='shopping-list-name'
          type='text'
          color={error ? colors.red : colors.black}
          maxLength={SHOPPING_LIST_TITLE_MAX_LENGTH}
        />
      </InputContainer>
      <Message>{error || t('shoppingList.create.info')}</Message>
      <ActionButton onClick={onSubmit} submitLoading={isLoading} disabled={!name || error}>
        {isLoading && <CircularProgressStyled size={16} />}
        <ButtonLiteral>{t('shoppingList.create.submit')}</ButtonLiteral>
      </ActionButton>
    </Modal>
  )
}

ModalCreateShoppingList.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
}

ModalCreateShoppingList.defaultProps = {
  showModal: false,
  setShowModal: () => {},
}

export default ModalCreateShoppingList
